import type { AxiosResponse } from 'axios'

interface ExportedReportPayload {
  data?: BlobPart
  headers?: AxiosResponse<Blob, unknown>['headers']
}

type ExportedReportResponse =
  | (Blob & ExportedReportPayload)
  | (ExportedReportPayload & { data: BlobPart })

export function downloadBlob(blob: Blob | MediaSource, filename: string): void {
  const urlApi = window.URL
  const url = urlApi.createObjectURL(blob)
  const anchor = document.createElement('a')
  const revokeObjectUrl = urlApi.revokeObjectURL.bind(urlApi)

  anchor.href = url
  anchor.download = filename
  document.body.appendChild(anchor)
  anchor.click()

  // Let the browser finish handing the blob off to the download manager before cleanup.
  window.setTimeout(() => {
    anchor.remove()
    revokeObjectUrl(url)
  }, 1000)
}

export function getFilenameFromContentDisposition(
  contentDisposition: unknown,
  fallbackFilename: string
): string {
  if (typeof contentDisposition !== 'string') return fallbackFilename
  const match = contentDisposition.match(/filename="?([^"]+)"?/)

  return match?.[1] || fallbackFilename
}

export function downloadExportedReport(
  response: ExportedReportResponse,
  fallbackFilename: string
): void {
  const contentDisposition: unknown = response?.headers?.['content-disposition'] ?? ''
  const filename = getFilenameFromContentDisposition(contentDisposition, fallbackFilename)
  const blob =
    response instanceof Blob
      ? response
      : response?.data instanceof Blob
        ? response.data
        : new Blob([response?.data ?? response])

  downloadBlob(blob, filename)
}
